/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateItemCommandResult } from '../../models/create-item-command-result';

export interface ApiNurseryManagerItemsCreateItemPost$Params {
      body?: {
'Name'?: string;
'Description'?: string;
'CategoryId': string;
'File'?: Blob;
}
}

export function apiNurseryManagerItemsCreateItemPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerItemsCreateItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateItemCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerItemsCreateItemPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateItemCommandResult>;
    })
  );
}

apiNurseryManagerItemsCreateItemPost.PATH = '/api/NurseryManager/Items/CreateItem';
